<template>
  <div>
    <!-- Navigation Buttons -->
    <div id="outer-container">
      <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
        <div class="card-content">
          <div class="clearfix row pad-lf-10 pad-rg-10">
            <!-- <a class="btn btn-fill btn-primary" :class="{ active: isApp }" @click="openTab('app')">
              {{$t('settingsPages.app')}}
            </a>

            <a class="btn btn-fill btn-primary" :class="{ active: isCompanyWeb }" @click="openTab('companyWeb')">
              {{$t('settingsPages.companyWeb')}}
            </a> -->

            <a class="btn btn-fill btn-primary" :class="{ active: isMeasurementsUnits }" @click="openTab('measurementsUnits')">
              {{$t('settingsPages.measurementsUnits')}}
            </a>

            <a class="btn btn-fill btn-primary" :class="{ active: isTableZones }" @click="openTab('tableZones')">
              {{$t('settingsPages.tableZones')}}
            </a>

            <a class="btn btn-fill btn-primary" :class="{ active: isTableManager }" @click="openTab('tableManager')">
              {{$t('settingsPages.tableManager')}}
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Contents -->
    <div v-if="isApp">
      <app-form :modeldata="model" :defaultData="defaultData"></app-form>
    </div>

    <div v-if="isCompanyWeb">
      <company-web-form :modeldata="websiteData"></company-web-form>
    </div>

    <div v-if="isMeasurementsUnits">
      <template v-if="selectedMeasurementsUnits !== false">
        <measurements-units-form
          @on-submit="onUserSubmit"
          :callback="measurementsUnitsUpdate"
          :zoneId="selectedMeasurementsUnits"
        ></measurements-units-form>
      </template>
      <template v-else>
        <measurements-units-list
          ref="tableMeasurementsUnits"
          :isTable="isMeasurementsUnits"
          :callback="getMeasurementsUnits"
        ></measurements-units-list>
      </template>
    </div>

    <div v-if="isTableZones">
      <template v-if="selectedZone !== false">
        <table-zone-form
          @on-submit="onUserSubmit"
          :callback="tableZoneUpdate"
          :zoneId="selectedZone"
        ></table-zone-form>
      </template>
      <template v-else>
        <table-zone-list
          ref="tableZone"
          :isTable="isTableZones"
          :callback="getZone"
        ></table-zone-list>
      </template>
    </div>

    <div v-if="isTableManager">
      <template v-if="selectedTable !== false">
        <table-management-form
          @on-submit="onUserSubmit"
          :callback="tableManagementUpdate"
          :tableId="selectedTable"
          :posUsers="formattedUsers"
        ></table-management-form>
      </template>
      <template v-else>
        <table-management-list
          ref="tableManagement"
          :isTable="isTableManager"
          :callback="getTable"
          :posUsers="formattedUsers"
        ></table-management-list>
      </template>
    </div>
  </div>
</template>

<script>
import AppForm from './Tabs/App.vue'
import CompanyWebForm from './Tabs/CompanyWeb.vue'
import MeasurementsUnitsForm from './MeasurementsUnits/MeasurementsUnitsForm.vue'
import MeasurementsUnitsList from './MeasurementsUnits/MeasurementsUnits.vue'
import TableZoneForm from './TableZones/TableZonesForm.vue'
import TableZoneList from './TableZones/TableZones.vue'
import TableManagementForm from './TableManagement/TableManagementForm.vue'
import TableManagementList from './TableManagement/TableManagement.vue'

export default {
  components: {
    AppForm,
    CompanyWebForm,
    MeasurementsUnitsForm,
    MeasurementsUnitsList,
    TableZoneForm,
    TableZoneList,
    TableManagementForm,
    TableManagementList
  },
  data () {
    return {
      tabName: 'app',

      // Tab state
      isApp: false,
      isCompanyWeb: false,
      isMeasurementsUnits: true,
      isTableZones: false,
      isTableManager: false,

      // Selected rows/items for forms
      selectedMeasurementsUnits: false,
      selectedZone: false,
      selectedTable: false,

      // Reactive data objects
      model: {},          // Pentru AppForm și CompanyWebForm
      defaultData: {},    // Pentru date default
      websiteData: [],    // Pentru CompanyWebForm

      posUsers: []        // Pentru TableManagementList/Form
    }
  },
  computed: {
    formattedUsers () {
      return this.posUsers.map(user => ({
        ...user,
        fullname: `${user.firstname} ${user.lastname}`
      }))
    }
  },
  created () {
    this.getModelData()

    this.getPosUsers()
  },
  methods: {
    getPosUsers () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/pos/all/users', 'GET', data, (response) => {
        if (response.status) {
          this.posUsers = response.data.pos_user
        }
      })
    },
    getModelData () {
      const token = this.$session.get('token')
      const companyID = this.$session.get('selectedCompany')

      this.apiRequest('/settings/general/' + companyID, 'GET', { token }, (response2) => {
        if (response2.status === true) {
          this.model = response2.data[0]
          this.model.selected_languages = response2.data[0].languages.map(lang => ({
            value: lang.id,
            label: lang.name
          }))
        }
      })

      this.apiRequest('/settings/website', 'GET', {
        token,
        company_id: companyID
      }, (response) => {
        if (response.status === true) {
          this.websiteData = response.data
          console.log('this.websiteData', this.websiteData)
        }
      })
    },
    openTab (tab) {
      // Resetează toate stările
      this.isApp = false
      this.isCompanyWeb = false
      this.isMeasurementsUnits = false
      this.isTableZones = false
      this.isTableManager = false

      // Mapare tab -> proprietate
      const tabMap = {
        app: 'isApp',
        companyWeb: 'isCompanyWeb',
        measurementsUnits: 'isMeasurementsUnits',
        tableZones: 'isTableZones',
        tableManager: 'isTableManager'
      }

      // Activează tab-ul selectat
      const prop = tabMap[tab] || 'isTableManager'
      this[prop] = true
      this.tabName = tab
    },
    onUserSubmit (model, isValid) {
    },
    // Callbacks pentru child components
    tableManagementUpdate () {
      this.selectedTable = false
      if (this.$refs.tableManagement) this.$refs.tableManagement.getData()
    },
    measurementsUnitsUpdate () {
      this.selectedMeasurementsUnits = false
      if (this.$refs.tableMeasurementsUnits) this.$refs.tableMeasurementsUnits.getData()
    },
    tableZoneUpdate () {
      this.selectedZone = false
      if (this.$refs.tableZone) this.$refs.tableZone.getData()
    },
    getTable (id) { this.selectedTable = id },
    getMeasurementsUnits (id) { this.selectedMeasurementsUnits = id },
    getZone (id) { this.selectedZone = id }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/SettingsModules.vue